import { useState } from "react";
import { buttonVariants } from "@/components/ui/button";
import { SelectDeviceCard } from "@/components/select-device-card";
import { proxyImageUrl } from "@/lib/snipeit/client";
import type { SnipeItAsset } from "@/lib/snipeit/types";
import { Link } from "wouter";

export function SearchDeviceView() {
  const [selected, setSelected] = useState<SnipeItAsset | null>(null);

  const imageUrl = proxyImageUrl(selected?.image);

  return (
    <main className="bg-background flex min-h-dvh items-start justify-center overflow-y-auto px-4 pt-6 pb-6 md:h-dvh md:overflow-hidden">
      <div className="flex w-full max-w-3xl flex-col gap-3">
        <div className="flex w-full flex-col items-start gap-6 md:flex-row md:overflow-hidden">
          <div className="w-full shrink-0 space-y-3 md:w-80">
            <SelectDeviceCard
              queryKeyPrefix="search"
              onSelect={(asset) => {
                setSelected(asset);
              }}
            />

            <div className="flex flex-wrap items-center justify-between gap-2">
              <Link href="/" className={buttonVariants({ variant: "secondary", size: "sm" })}>
                Zurück
              </Link>
            </div>
          </div>

          {imageUrl && (
            <div className="border-border bg-card max-h-[40dvh] w-full overflow-hidden rounded-xl border shadow-sm md:max-h-[calc(100vh_-_100px)] md:flex-1">
              <img
                src={imageUrl}
                alt={selected?.model?.name ?? selected?.name}
                className="h-full w-full object-contain p-4"
              />
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
